module.exports = __webpack_public_path__ + "static/media/instagram-icon.63490499.svg";